import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CategoryProductsPage from './pages/CategoryProductsPage';
import PrivateRoute from "./PrivateRoute";
import Login from "./Login.js"; 

const App = () => {
  return (
    <Router>
      <Routes>
      <Route path="/" element={<Login />} />
        <Route path="/home" element={<PrivateRoute element={<Home />} />} />
        <Route path="/category/:categoryId" element={<PrivateRoute element={<CategoryProductsPage />} />} />
      </Routes>
    </Router>
  );
};

export default App;
